$(document).ready(function () {
  $(".hummenu_container").on("click", function () {
    $(".overlay").addClass("active");
    $("html").css("overflow", "hidden"); // Disable scrolling
  });

  $(".overlay-close").on("click", function () {
    $(".overlay").removeClass("active");
    $("html").css("overflow", ""); // Re-enable scrolling
  });

  const $checkoutButtons = $(".popUpBtn");
  const $directCheckoutButtons = $(".no-upsell-button");
  const $checkoutPopup = $("#checkoutPopup");
  const $proPlanPopup = $("#proPlanPopup");
  const $justMicButton = $(".just-mic-button");
  const $closePopupBtn = $("#closeBTn");
  const $closeProPlanBtn = $("#closeProPlanBtn");
  const $proPlanLabel = $(".Pro_plan_label");
  const $studioPlanLabel = $(".studio_plan_label");
  const $substudioPlan = $("#substudioPlan");
  let currentVariantId = null;

  // 1. Set variant ID on button click
  $checkoutButtons.on("click", function () {
    currentVariantId = $(this).data("variant-id");
    console.log("Variant set:", currentVariantId);
    if (!currentVariantId) {
      alert("Error: Missing product variant. Please refresh the page.");
      return;
    }
    $checkoutPopup.css("display", "flex");
  });

  $directCheckoutButtons.on("click", function () {
    currentVariantId = $(this).data("variant-id");
    console.log("Variant set:", currentVariantId);
    if (!currentVariantId) {
      alert("Error: Missing product variant. Please refresh the page.");
      return;
    }
  });

  // 2. Toggle between popups
  $proPlanLabel.on("click", function () {
    $checkoutPopup.hide();
    $proPlanPopup.css("display", "flex");
  });

  $studioPlanLabel.on("click", function () {
    $proPlanPopup.hide();
    $checkoutPopup.css("display", "flex");
  });

  // 3. Checkout buttons (both use the same variant)
  $justMicButton.on("click", checkoutWithCurrentVariant);
  $directCheckoutButtons.on("click", checkoutWithCurrentVariant);

  function checkoutWithCurrentVariant() {
    if (!currentVariantId) {
      alert("Please select a plan first.");
      return;
    }
    addToCartAndCheckout(currentVariantId);
  }

  // Improved cart function with error details
  function addToCartAndCheckout(variantId) {
    console.log("Trying to add to cart:", variantId);
    $.ajax({
      url: "/cart/add.js",
      method: "POST",
      dataType: "json",
      data: {
        items: [
          {
            id: variantId,
            quantity: 1,
          },
        ],
      },
      success: function (response) {
        localStorage.setItem("goingToCheckout", "true");
        console.log("Cart response:", response);
        window.location.href = "/checkout";
      },
      error: function (error) {
        console.error("Cart error:", error.responseJSON || error);
        alert(
          `Error: ${
            error.responseJSON?.description || "Could not add to cart."
          }`
        );
      },
    });
  }

  //SUBSCRIPTION PROD ADDON CODE START
  const AddOnPlusMainVariantAddToCart = (mainBtn) => {
    let finalProdForCart = [];
    const addOnVariantId = mainBtn.attr("data-sub-variant-id");
    const sellingPlanId = mainBtn.attr("data-selling-plan-id");
    const planName = mainBtn.attr("data-planName");
    
    // Store original button text if not already stored
    if (!mainBtn.data('original-html')) {
        mainBtn.data('original-html', mainBtn.html());
    }

    // Show loading state
    mainBtn
        .empty()
        .html(`<span class="button is-loading is-loading--icon-only"></span>`)
        .addClass("focused");

    // Prepare cart items
    finalProdForCart.push(
        { 
            id: addOnVariantId, 
            quantity: 1, 
            selling_plan: sellingPlanId,
            properties: { "Plan Name": planName } 
        }, // Add-on product
        { id: currentVariantId, quantity: 1, properties: {} } // Main product
    );

    $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: { items: finalProdForCart },
        dataType: "json",
        success: function () {
            localStorage.setItem("goingToCheckout", "true");
            
            // Update button to "Added" and keep focused class
            mainBtn.empty().html("Added").addClass("focused");
            
            // Redirect to checkout - button state persists until page unloads
            setTimeout(() => {
                window.location.href = "/checkout";
            }, 1000);
        },
        error: function() {
            // Only revert if there's an error
            mainBtn.empty().html(mainBtn.data('original-html')).removeClass("focused");
        }
    });
  };

  //SUBSCRIPTION PROD ADDON CODE end

  // Close popups
  $closePopupBtn.on("click", () => $checkoutPopup.hide());
  $closeProPlanBtn.on("click", () => $proPlanPopup.hide());
  $(document).on("click", ".subscription_btn", function () {
    const $this = $(this);
    AddOnPlusMainVariantAddToCart($this);
  });

  
  $(document).on("click", ".checkout", function () {
    localStorage.setItem("goingToCheckout", "true");
  });
  
   const clearCartAfterCheckout = () => {
    if (localStorage.getItem("goingToCheckout") === "true") {
    localStorage.removeItem("goingToCheckout");
    // Clear cart using Shopify's endpoint
    fetch("/cart/clear.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.ok) {
          // Refresh cart contents if using AJAX cart
          if (
            typeof theme !== "undefined" &&
            typeof theme.cart !== "undefined"
          ) {
            theme.cart.getCart();
          }
          // Optional: redirect to cart page to show empty state
          // window.location.href = "/cart";
        }
      })
      .catch((error) => {
        console.error("Error clearing cart:", error);
        // Fallback to traditional form submission
        const form = document.createElement("form");
        form.method = "POST";
        form.action = "/cart/clear";
        document.body.appendChild(form);
        form.submit();
      });
    }
  };
    // calling function on  load  
  clearCartAfterCheckout();
});
